import { useEffect } from "react";

/** localStorage key ενός κουπονιού που "κρατιέται" από URL έως το checkout. */
export const PENDING_COUPON_KEY = "pending_coupon";

/**
 * Auto-apply κουπονιού από URL: `?coupon=CODE`. Αποθηκεύει τον κωδικό στο
 * localStorage ώστε το checkout να τον προσυμπληρώσει και να τον εφαρμόσει.
 * Ο server πάντα το επανελέγχει αυθεντικά κατά την παραγγελία.
 */
export function useAutoApplyCoupon() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("coupon");
      if (code && code.trim()) {
        window.localStorage.setItem(PENDING_COUPON_KEY, code.trim().toUpperCase());
      }
    } catch {
      /* ignore */
    }
  }, []);
}
